import React, { ButtonHTMLAttributes, ReactNode } from 'react';

export interface TextLinksButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  fontCase?: 'normal-case' | 'uppercase';
  textVariant?: 'light' | 'dark';
}

export const TextLinks = ({
  children,
  className,
  disabled,
  fontCase,
  textVariant,
  type = 'button',
  ...rest
}: TextLinksButtonProps) => {
  return (
    <button
      type={type}
      className={`text-btn-links font-semibold bg-none border-0 font-open-sans ${
        textVariant !== ('dark' || 'light') && 'text-utility-link-info'
      } ${textVariant === 'light' && 'text-thryv-steel'} ${
        textVariant === 'dark' && 'text-thryv-cornflower-500'
      } ${
        fontCase === 'uppercase' ? 'uppercase' : 'normal-case'
      } disabled:text-thryv-steel visited:text-thryv-cornflower-500 ${
        className && className
      }`}
      disabled={disabled}
      {...rest}
    >
      {children}
    </button>
  );
};
